import firebase from "firebase";


const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
  };
  // Initialize Firebase
  const firebaseApp=firebase.initializeApp(firebaseConfig);

  const auth=firebase.auth();//handles auth wala kaam
  const db=firebase.firestore();//to access db

  const provider = new firebase.auth.GoogleAuthProvider();

  export {auth,db,provider};